import { buildTemplate } from './buildTemplate';
import { expandMsTokens } from './expandMsTokens';
import { normalizeTokens } from './normalizeTokens';
import { GridTemplateInputToken, GridTemplateToken } from './types';

/**
 * A repeat takes a series of lengths and repeats them a given number of times.
 */
export class Repeat implements GridTemplateToken {
  public constructor(private num: number, private pattern: Exclude<GridTemplateToken, Repeat>[]) {}

  public expandMsTokenWithGap(gap: string): string[] {
    if (this.num === 0) {
      return [];
    }

    const expandedPattern = expandMsTokens(this.pattern, gap);
    if (this.num === 1) {
      return [expandedPattern, gap];
    }

    return [`(${expandedPattern} ${gap})[${this.num - 1}]`, expandedPattern, gap];
  }

  public expandMsToken(): string {
    if (this.num === 0) {
      return '';
    }

    return `(${expandMsTokens(this.pattern)})[${this.num}]`;
  }

  public expandToken(): string {
    if (this.num === 0) {
      return '';
    }

    return `repeat(${this.num}, ${buildTemplate(this.pattern)})`;
  }
}

/**
 * Factory function for creating Repeats to be used in a grid layout.
 *
 * @param num The number of times the pattern is to be repeated
 * @param pattern The arrangement of the pattern
 */
export const repeat = (num: number, pattern: Exclude<GridTemplateInputToken, Repeat>[]): Repeat =>
  new Repeat(num, normalizeTokens(pattern));
